import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

export const formatPostType = (post, type) => {
  let postObj = post;
  let image = {};
  post.image &&
    Object.keys(post.image.sizes).map((size) => {
      image[size] = {
        ...post.image.sizes[size],
        source_url: post.image.sizes[size].url,
      };
    });

  if (type !== "tribe_events") {
    let image = null;
    try {
      image = post["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"];
    } catch (e) {}

    postObj = { ...post, image };
  }

  return postObj;
};
